import React from "react";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../constants/languages";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = theme => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block"
    }
  }
});

const UpgradeButton = props => (
  <div>
    <Button
      className={props.classes.button}
      color="inherit"
      style={{ color: "white" }}
      onClick={props.toggleUpgradeDialog}
      disabled={!props.canUpgrade}
    >
      <img
        style={{ height: 20, marginRight: 5 }}
        src={props.upgradeLogo}
        alt=""
      />
      <span className={props.classes.buttonText}>
        {props.status > 0
          ? languages.tournamentStatus[props.status].name
          : languages.upgrade.upgrade}
      </span>
    </Button>
    <IconButton
      className={props.classes.iconButton}
      color="inherit"
      style={{ color: "white" }}
      onClick={props.toggleUpgradeDialog}
      disabled={!props.canUpgrade}
    >
      <img
        style={{ height: 20, marginRight: 5 }}
        src={props.upgradeLogo}
        alt=""
      />
    </IconButton>
  </div>
);

UpgradeButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UpgradeButton);
